'use strict';

wbApp.controller('ActivityReservationDetailCtrl', ['$scope', '$q', 'activityReservationSvc', 'activityStudentSettingSvc',
function ($scope, $q, activityReservationSvc, activityStudentSettingSvc) {

    $scope.studentDetailModel = { days: [], onDataSourceChange: function () { }, applyChanges: function () { }};
    $scope.reservationsOrig = [];


    function reloadData(reservations, schedules, studentID, activityID, setting) {
        // todo: Check changes

        var model = activityReservationSvc.createStudentDetailModel(reservations, schedules, studentID, activityID, setting);
        $scope.reservationsOrig = angular.copy(reservations);
        $scope.activityTarifOrig = angular.copy(setting);
        $scope.studentDetailModel = model;
    }

    $scope.onStudentChange = function (studentID) {
        var res = activityReservationSvc.getAllByStudentAndActivity(
            studentID, $scope.reservationDetailModel.activityID);
        var set = activityStudentSettingSvc.getByStudentAndActivity(studentID, $scope.reservationDetailModel.activityID);

        $q.all([res.$promise, set])
        .then(function (data) {

            var reservations = data[0];
            var setting = data[1];

            setting.activityID = $scope.reservationDetailModel.activityID;
            setting.studentID = studentID;

            reloadData(reservations, $scope.reservationDetailModel.selection, studentID, $scope.reservationDetailModel.activityID, setting);
        }); 
    }

    $scope.onWeekSelectionChange = function (selection) {
        $scope.studentDetailModel.applyChanges.call($scope.studentDetailModel);
        $scope.studentDetailModel.onDataSourceChange.call($scope.studentDetailModel);
    }

    $scope.saveActivityReservationDetailChanges = function () {

        if ($scope.isSaving) {
            return;
        }

        $scope.studentDetailModel.applyChanges.call($scope.studentDetailModel);

        $scope.isSaving = true;

        var res = activityReservationSvc.saveAsync(
            $scope.studentDetailModel.reservations,
            $scope.reservationDetailModel.studentID,
            $scope.reservationDetailModel.activityID,
            $scope.reservationsOrig);

        var tar = activityStudentSettingSvc.saveAsync(
            $scope.studentDetailModel.activitySetting,
            $scope.activityTarifOrig);

        $q.all([res, tar])
        .then(function (data) {
            var resources = data[0];
            $scope.onActivityReservationSave(resources);
        }, function (reason) {
            $scope.activityReservationDetailError = reason;
            $scope.isSaving = false;                
        });
    }

    if (!$scope.reservationDetailModel.isNew) {
        $scope.onStudentChange($scope.reservationDetailModel.studentID);
    }

    $scope.detailTabs = [
    {
        title: 'TXT_MAIN',
        template: "activities/activity-reservation/detail-main-tab.html"
    },
    {
        title: 'TXT_MENU_SETTING',
        template: "activities/activity-reservation/detail-settings-tab.html"
    }];

    $scope.detailTabs.activeTab = 0;

}]);